module.exports = __webpack_public_path__ + "img/4.fa46a1fc.svg";